import React from 'react'
import { TextTypes } from '../../../types/TextTypes'
import { Text } from '../Text'

export interface TabProps {
    isActive?: boolean
    children: React.ReactChild
}

export const Tab = ({ isActive = false, children }: TabProps) => {
    const isActiveClasses = isActive
        ? 'tab--active text-accent-700 pointer-events-none'
        : 'tab--inactive cursor-pointer'

    return (
        <div className={'tab relative w-auto inline-flex ' + isActiveClasses}>
            {isActive && <span className="absolute bg-accent-700 top-0 left-0 right-0 h-0.5" />}
            <Text type={TextTypes.BUTTON_DEFAULT}>{children}</Text>
        </div>
    )
}
